import { Button } from '@design/components/button/Button';
import { RenderFeatureFlag } from '@terminal/components/render-feature-flag/RenderFeatureFlag';
import { useTranslation } from 'react-i18next';

export interface DownloadButtonProps {
  onClick: () => void;
  className?: string;
}

export const DownloadButton = ({ onClick, className }: DownloadButtonProps) => {
  const { t } = useTranslation(['widget']);

  return (
    <RenderFeatureFlag requiredFlag={'drawer_download'}>
      <Button
        iconName="CloudArrowDown"
        label={t('widget:downloadInsight')}
        onClick={onClick}
        variant="empty"
        size="xsmall"
        className={className}
      />
    </RenderFeatureFlag>
  );
};
